











































































































import Vue from 'vue'

export default Vue.extend({
  name: 'AuthorizationAlert',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      default: () => (): void => { }
    }
  },
  data () {
    return {
      dialogStatus: false
    }
  },
  methods: {
    updated () {
      setTimeout(() => {
        this.close()
      }, 5000)
    }
  },
  model: {
    prop: 'dialog',
    event: 'changeState'
  },
  watch: {
    dialogStatus () {
      this.$emit('changeState', this.dialogStatus)
    },
    dialog () {
      this.dialogStatus = this.dialog
    }
  }
})
